/**
 * The renderer's claim about a tab's transaction, attached to every statement
 * (`useQueryExecution`) and every result-grid Save (`useResultsEditing`) so the
 * backend can refuse — with `TRANSACTION_SESSION_MISSING` — anything that would
 * otherwise run in auto-commit or on a replacement session.
 */

import type { Tab } from '../../core/types/workspaceTypes';

export type TransactionSessionClaim = {
  transactionSessionExpected?: boolean;
  transactionSessionGeneration?: number;
};

export function transactionSessionClaimForTab(tabs: Tab[], tabId: string): TransactionSessionClaim {
  const tab = tabs.find((t) => t.id === tabId);
  if (!tab || tab.type !== 'query') return {};
  const state = tab.content.transactionState;
  if (state !== 'active' && state !== 'error') return {};
  const generation = tab.content.transactionSessionGeneration;
  return {
    transactionSessionExpected: true,
    ...(generation !== undefined ? { transactionSessionGeneration: generation } : {}),
  };
}
